import type { FC } from 'react';
import React from 'react';
import type { DatePickerProps } from '../DatePicker/DatePicker';
import { DatePicker } from '../DatePicker/DatePicker';
import type { StrictOmit, WithRequired } from '../Utils/typeUtils';
import styles from './DatePickerFloating.module.css';
import type { FloatingWrapperProps } from './FloatingWrapper/FloatingWrapper';
import { FloatingWrapper } from './FloatingWrapper/FloatingWrapper';

type DatePickerFloatingProps = WithRequired<DatePickerProps, 'ariaHeader'> & {
    floatingConfig: StrictOmit<FloatingWrapperProps, 'ariaLabelledby'>;
};

export const DatePickerFloating: FC<React.PropsWithChildren<DatePickerFloatingProps>> = props => {
    const { floatingConfig, children, config, ...restProps } = props;
    const { ariaHeader } = restProps;
    const { open } = floatingConfig;

    return (
        <FloatingWrapper {...floatingConfig} ariaLabelledby={ariaHeader.id}>
            {open && (
                <DatePicker {...restProps} config={config} open={open} className={styles.DatePickerFloating}>
                    {children}
                </DatePicker>
            )}
        </FloatingWrapper>
    );
};
